import actionTypes from '../constants/action-types';

const setStatus = (status) => ({
  type: actionTypes.SET_STATUS,
  payload: {
    status,
  },
});

export default setStatus;
